module.exports = __webpack_public_path__ + "static/media/Ford-Ranger-2WD-Lo-Ride-2018-2.692808c2.webp";